import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { CommonFieldProps } from "./types";

export const BooleanField = ({ name, data, getValue }: CommonFieldProps) => {
  const value = getValue ? getValue(data) : data[name];

  return value ? (
    <CheckRoundedIcon fontSize="small" color="success" />
  ) : (
    <CloseRoundedIcon fontSize="small" color="error" />
  );
};
